module.exports = __webpack_public_path__ + "static/media/missing-letters.029ac8bc.png";